// extracted by mini-css-extract-plugin
export default {"drawer-logo":"drawer-logo-QUPav","nav-link":"nav-link-BzkHt","nav-link-btn":"nav-link-btn-ZSrCZ","nav-link-dashboard":"nav-link-dashboard-nliMP"};